import { useRecoilValue } from 'recoil'
import { Subtitle, SubtitleTextBold } from '../ClaimDetailTitle/styles'
import { toThaiLocaleFullDateAndTime } from '@/libs/date'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'

const ClaimInfoSubtitle = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const isCreateMode = healthClaim.mode === HealthClaimModeEnum.CREATE
  const formattedTimestamp = healthClaim.data?.lastUpdateAt
    ? toThaiLocaleFullDateAndTime(healthClaim.data?.lastUpdateAt.toString())
    : 'N/A'

  return (
    !isCreateMode && (
      <Subtitle>
        เลขรับแจ้ง <SubtitleTextBold>{healthClaim.data?.notifyNumber || 'N/A'}</SubtitleTextBold>
        ・เลขเคลม <SubtitleTextBold>{healthClaim.data?.claimNumber || 'N/A'}</SubtitleTextBold>
        ・อัปเดตข้อมูลล่าสุด{' '}
        <SubtitleTextBold>{healthClaim.data?.lastUpdateBy || 'N/A'}</SubtitleTextBold>・
        <SubtitleTextBold>{formattedTimestamp}</SubtitleTextBold>
      </Subtitle>
    )
  )
}

export default ClaimInfoSubtitle
